<template>
  <div>
    <campaignHeader
      :cover="header_data.cover" 
      :logo="header_data.logo"
      :name="campaingName" 
      :data_left="array_left_header"
      :data_right="array_right_header"
      :badge="{traduction: ['oneCampaigninactive', 'oneCampaignactive'], value: header_data.is_archived}"
      :external_campaign_id="header_data.external_campaign_id"
      @clickCalendar="clickCalendar"
      @updateBudget="updateBudget"
      @showInfluencer="showInfluencer"
      @showModalImport="modal_csv_import = true"
      :processing="processing"
      @update_logo_cover="updateLogoCover"
      :disabledUpdateCampaign="disabledUpdateCampaign()"
      ref="campaignHeader"
    />
    <transition name="yt-alert-fade">
      <div
        v-if="!channel_brand_youtube && show_yt_alert && header_data.external_campaign_id"
        class="yt-alert-wrapper"
        :class="is_editable_by_api ? 'yt-alert--warning' : 'yt-alert--danger'"
      >
        <div class="yt-alert-inner">
          <div class="yt-alert-icon">
            <feather-icon :icon="is_editable_by_api ? 'YoutubeIcon' : 'AlertTriangleIcon'" size="20" />
          </div>
          <div class="yt-alert-content">
            <p class="yt-alert-title">{{ is_editable_by_api ? $t('campaigns.youtube_banner_editable_title') : $t('campaigns.youtube_banner_readonly_title') }}</p>
            <p class="yt-alert-msg">{{ is_editable_by_api ? $t('campaigns.youtube_banner_editable_msg') : $t('campaigns.youtube_banner_readonly_msg') }}</p>
          </div>
          <b-button
            v-if="is_editable_by_api"
            variant="warning"
            size="sm"
            class="yt-alert-btn flex-shrink-0"
            @click="$router.push({ name: 'brief', params: { uuid: $route.params.uuid }, query: { openYoutube: '1' } })"
          >
            {{ $t('campaigns.youtube_banner_editable_btn') }}
          </b-button>
          <button class="yt-alert-close" @click="show_yt_alert = false" aria-label="Cerrar">
            <feather-icon icon="XIcon" size="16" />
          </button>
        </div>
      </div>
    </transition>
    <b-tabs class="mt-4 campaign-tabs-principal-inner" v-model="principal_tabs" active-nav-item-class="campaign-tabs-principal-active">
      <b-tab @click="isHidden = false; showAnalytics = false" class="tab-table-cards-influencer">
        <template #title>
          <feather-icon icon="UsersIcon" />
          <span>{{ $t('campaigns.profileProposals') }}</span>
        </template>
        <all-users ref="all-user" @openSidebar="showInfluencer()" @update_header_data="updateHeaderData" @update_counter_header="updateCounter" :campaign_name="campaingName" :header_data="header_data" @update_header_campaign="getCampaign" :key="updated_all_user"/>
      </b-tab>
      
      <!-- Managuing -->
      <b-tab>
        <template #title>
          <feather-icon icon="UserCheckIcon" />
          <span>{{ $t('campaigns.squadCampaign') }}</span>
        </template>

          <newTopCreator
            ref="squad-table"
            v-if="principal_tabs === 1"
            :slug="slug_name"
            @formatHeader="formatHeader"
            @update_header="getCampaign"
          />
      </b-tab>

      <!-- Contents -->
      <b-tab @click="isHidden = true">
        <template #title>
          <feather-icon icon="CoffeeIcon" />
          <span>{{$t('campaigns.contents')}}</span>
        </template>
            <PublishContent class="mt-2"
              ref="contents-table"
              :slug="slug_name"
              v-if="principal_tabs === 2"
              @update_header="getCampaign"
              :code_campaign="header_data.external_campaign_id || null"
            />
      </b-tab>

      <!-- Calendar -->
      <b-tab 
        empty
        @click="isHidden = true"  
      >
        <template #title>
          <feather-icon icon="CalendarIcon" />
          <span>{{$t('campaigns.calendar')}}</span>
        </template>
        <calendar-influencers :key="principal_tabs"/>
      </b-tab>

      <!-- Overview -->
      <b-tab>
        <template #title>
          <feather-icon icon="EditIcon" />
          <span>Overview</span>
        </template>
        <b-tabs content-class="mt-2">
          <b-tab
            :title="$t('campaigns.drag_drop')"
          >
            <dragDropStatus 
              :approvedManaging="usersManage" 
              v-if="principal_tabs === 4"
              @update_header="updateHeader"
              @update_influencers="getCampaign"
            />
          </b-tab>
        </b-tabs>
      </b-tab>

      <!-- Analytics -->
      <b-tab :disabled="!showNewAnalytics">
        <template #title>
          <feather-icon icon="BarChart2Icon" />
          <span>{{ $t('campaigns.analytics') }}</span>
        </template>

        <analytics-campaign :campaingName="campaingName" v-if="showNewAnalytics && principal_tabs === 5" @print-requested="handlePrint"/>
      </b-tab>    

    </b-tabs>

    <add-influencer 
      @childPost="influencerAdded" 
      @update_header="updateHeader" 
      @update_header_campaign="updateHeader"
      :show_side_influencer="sidebar_right"
      :key="has_changed_influencer"
    />

    <!-- CSV import modal: temporarily removed while back-end is being adapted -->
    <!-- <b-modal
      v-model="modal_csv_import"
      centered
      :title="$t('lists.addListTextCampaign')"
      hide-footer
      @close="closeFile"
    >

      <b-link href="https://brandme.la/wp-content/template_listas.csv">
        <feather-icon icon="DownloadIcon"/>
        {{$t('campaigns.download_template')}}
      </b-link>

      <validation-observer ref="updateProfile" #default="{ invalid }">
        <validation-provider rules="required">
          <b-form-file
            accept=".csv"
            class="mt-1"
            v-model="fileCsv"
            :placeholder="$t('lists.addListText1')"
            :browse-text="$t('uploadFile')"
          ></b-form-file>
        </validation-provider>
        <b-button
          :disabled="invalid"
          variant="primary"
          class="my-1"
          @click="uploadFile"
        >
        {{$t('lists.upload')}}
        </b-button>
      </validation-observer>
    </b-modal> -->
  </div>
</template>

<script>
import {
  BTabs, BTab, VBToggle, BButton
} from 'bootstrap-vue'
import campaignHeader from './campaignHeader.vue'
import newTopCreator from '@/views/components/campaign/newTopCreator.vue'
import dragDropStatus from '@/views/components/campaign/dragDropStatus.vue'
import PublishContent from '@/views/components/campaign/publishContent.vue'

import service from "@/services/campaign";
import CalendarInfluencers from '@/views/campaings/calendar/CalendarInfluencers.vue'
import AnalyticsCampaign from './AnalyticsCampaign.vue'
import { getMotivationalPhrase, print } from '@/libs/utils/others'
import { getUserData, hasPermission } from '@/libs/utils/user';

export default {
  components: {
    newTopCreator,
    campaignHeader,
    BTabs,
    BTab,
    dragDropStatus,
    CalendarInfluencers,
    PublishContent,
    AnalyticsCampaign,
    AddInfluencer: () => import('@/views/campaings/influencerSearch.vue'),
    AllUsers: () => import('@/views/components/campaign/alluser.vue'),
    BButton,
  },
  directives: {
    'b-toggle': VBToggle
  },
  data () {
    return {
      print,
      hasPermission,
      getUserData,
      getMotivationalPhrase,
      principal_tabs: 0,
      header_data: {},
      campaingName: '',
      slug_name: '',
      usersManage: {},
      infoRejected: [],
      isHidden: false,
      showAnalytics: false,
      fileCsv: null,
      processing: false,
      showNewAnalytics: false,
      tabs_content: 0,
      sidebar_right: false,
      array_right_header: [],
      array_left_header: [],
      modal_csv_import: false,
      secondary_tabs_proposals: 0,
      has_changed_influencer: false,
      key_approved: 0,
      key_rejected: 0,
      key_all: 0,
      key_pending: 0,
      key_onboarding: 0,
      key_trading: 0,
      key_producing: 0,
      key_submitted: 0,
      key_published: 0,
      interval_loading: null,
      printing: false,
      updated_all_user: 0,
      is_editable_by_api: true,
      channel_brand_youtube: null,
      show_yt_alert: true,
    }
  },
  created () {
    this.$vs.loading({
      type: 'sound',
      background: 'rgba(255, 255, 255, 1)',
      text: getMotivationalPhrase(),
    });

    this.interval_loading = setInterval(() => {
      const prev_loading = document.getElementsByClassName('con-vs-loading')[0]

      if (prev_loading) {
        prev_loading.classList.add('fade-out');
        setTimeout(function() {
          prev_loading.remove()
        }, 500);

        this.$vs.loading({
          type: 'sound',
          background: 'rgba(255, 255, 255, 1)',
          text: getMotivationalPhrase(),
        });
      }
    }, 5000);
    this.getCampaign()
    this.getCampaignData(this.$route.params.uuid)
    this.checkProcess()
    const self = this
    setTimeout(() => {
      self.checkHashParams()
    }, 500);

    const onScroll = () => {
      const scrollableHeight = document.body.scrollHeight - window.innerHeight;
      const scrollPosition = window.scrollY;

      if (scrollableHeight - scrollPosition <= 100 && !this.$refs[`all-user`]?.change_view_card && !this.$refs[`all-user`]?.loading_creators) {
        const ref = this.$refs[`all-user`];
        ref.current_page += 1;
        ref.getScrollInfiniteInfluencers();
      }
      if (scrollableHeight - scrollPosition <= 100 && !this.$refs[`squad-table`]?.view_list && !this.$refs[`squad-table`]?.loading_creators) {
        const ref = this.$refs[`squad-table`];
        ref.current_page += 1;
        ref.getScrollInfinite();
      }
    };
    window.addEventListener('scroll', onScroll);

    this.$root.$on('youtube_ycp_campaign_locked', (body) => {
      if (String(body.campaign_pk) === this.$route.params.uuid && this.is_editable_by_api) {
        this.is_editable_by_api = false
      }
    })
  },
  methods: {
    async handlePrint() {
      this.printing = true;

      await this.$refs.campaignHeader.convertImagesToBase64();

      window.scrollTo({ top: 0, behavior: 'smooth' });

      const self = this;
      setTimeout(function() {
        print('p', `Analytics de ${self.campaingName}`, document.body, function () {
          self.$refs.campaignHeader.restoreImages();
          self.printing = false;
        });
      }, 500);
    },
    getCampaign() {
      service.getCampaign(this.$route.params.uuid)
        .then(response => {
          this.slug_name = response.slug_name
          this.campaingName = response.name
          this.header_data = {
            logo: response.logo,
            cover: response.cover,
            is_archived: response.is_archived,
            budget: response.budget,
            production: response.stats_fields.production,
            proposals: response.stats_fields.proposals,
            published: response.stats_fields.published,
            spent: response.stats_fields.spent ? response.stats_fields.spent : 0,
            onboarding: response.stats_fields.onboarding,
            trading: response.stats_fields.trading,
            pending: response.stats_fields.pending,
            approved: response.stats_fields.approved,
            rejected: response.stats_fields.rejected,
            submitted: response.stats_fields.submitted,
            contents_published: response.stats_fields.contents_published,
            external_campaign_id: response.code_campaign || null,
          }
          this.is_editable_by_api = response.is_editable_by_api !== undefined ? response.is_editable_by_api : true
          this.channel_brand_youtube = response.channel_brand_youtube || null
          this.fillHeaderData()
          setTimeout(() => {
            clearInterval(this.interval_loading)
            this.$vs.loading.close()
          }, 500);
        })
    },
    updateLogoCover(data) {
      this.header_data.logo = data.logo;
      this.header_data.cover = data.cover;
    },
    checkOverviewUrl() {
      const list_urls = [];
      if (this.header_data.onboarding) list_urls.push('#propuestas-onboarding');
      if (this.header_data.trading) list_urls.push('#propuestas-negociando');
      if (this.header_data.producing) list_urls.push('#propuestas-produciendo');
      if (this.header_data.submitted) list_urls.push('#propuestas-enviadas');
      if (this.header_data.published) list_urls.push('#propuestas-publicadas');
      return list_urls;
    },
    checkHashParams() {
      const param = location.hash.replace('#', '')
      switch (param) {
      case 'propuestas':
        this.principal_tabs = 0
        this.secondary_tabs_proposals = 0
        break
      case 'propuestas-pendientes':
        this.principal_tabs = 0
        this.secondary_tabs_proposals = 1
        break
      case 'propuestas-aprobadas':
        this.principal_tabs = 0
        this.secondary_tabs_proposals = 2
        break
      case 'propuestas-rechazadas':
        this.principal_tabs = 0
        this.secondary_tabs_proposals = 3
        break
      case 'propuestas-onboarding':
        this.principal_tabs = 0
        this.secondary_tabs_proposals = 4
        break
      case 'propuestas-negociando':
        this.principal_tabs = 0
        this.secondary_tabs_proposals = 5
        break
      case 'propuestas-produciendo':
        this.principal_tabs = 0
        this.secondary_tabs_proposals = 6
        break
      case 'propuestas-enviadas':
        this.principal_tabs = 0
        this.secondary_tabs_proposals = 7
        break
      case 'propuestas-publicadas':
        this.principal_tabs = 0
        this.secondary_tabs_proposals = 8
        break
      case 'squad':
        this.principal_tabs = 1
        break
      case 'contenidos':
        this.principal_tabs = 2
        this.tabs_content = 0
        break
      case 'contenidos-vista':
        this.principal_tabs = 2
        this.tabs_content = 1
        break
      case 'calendario':
        this.principal_tabs = 3
        break
      case 'overview':
        this.principal_tabs = 4
        break
      case 'analytics':
        if (this.verifyEmptyStates() > 0) {
          this.principal_tabs = 5
        }
        break
      }
    },
    updateBudget(data) {
      this.array_right_header[2].value = `${data}`
    },
    showInfluencer() {
      this.sidebar_right = true;
      this.has_changed_influencer = !this.has_changed_influencer;
    },
    updateHeaderData(data_updated) {
      for (const i in data_updated) {
        this.header_data[i] = data_updated[i];
      }
    },
    formatHeader(data) {
      this.header_data.production = data.production
      this.header_data.proposals = data.proposals
      this.header_data.published = data.published
      this.header_data.spent = data.spent ? data.spent : 0
      this.header_data.onboarding = data.onboarding
      this.header_data.trading = data.trading
      this.header_data.pending = data.pending
      this.header_data.approved = data.approved
      this.header_data.rejected = data.rejected
      this.header_data.submitted = data.submitted
      this.showNewAnalytics = data.published > 0
    },
    verifyEmptyStates() {
      return this.header_data.approved + this.header_data.onboarding + this.header_data.trading + this.header_data.production + this.header_data.submitted + this.header_data.published;
    },
    updateHeader() {
      if (this.principal_tabs === 0) {
        this.$refs[`all-user`]?.getInfluencers();
      } else if (this.principal_tabs === 1) {
        this.$refs[`squad-table`]?.getCampaignManage();
      } else if (this.principal_tabs === 2) {
        this.$refs[`contents-table`]?.getCampaignManage();
      } else {
        this.getCampaignData(this.$route.params.uuid)
      }
    },
    clickCalendar() {
      this.principal_tabs = 3;
    },
    fillHeaderData() {
      const total_approved = [
        this.header_data.approved,
        this.header_data.onboarding,
        this.header_data.production,
        this.header_data.published,
        this.header_data.spent,
        this.header_data.submitted,
        this.header_data.trading,
      ].reduce((sum, val) => sum + (Number(val) || 0), 0);
      const array_left = [
        {traduction : 'proposalscard', value: this.header_data.proposals, key: 'proposals'},
        {traduction : 'campaigns.approvedProfiles', value: total_approved, key: 'approved'},
        {traduction : 'campaigns.onboarding', value: `${this.header_data.onboarding}`, key: 'onboarding'},
      ]
      const array_right = [
        {traduction : 'productioncard', value: this.header_data.production, key: 'production'},
        {traduction : 'publishedcard', value: this.header_data.contents_published, key: 'published'},
        {traduction : 'campaigns.budget', value: `${this.header_data.budget}`, key: 'budget'},
        // {traduction : 'spentcard', value:  `${this.header_data.spent}`, key: 'spent'},
      ]
      this.array_right_header = array_right;
      this.array_left_header = array_left;
    },
    checkProcess() {
      service.checkProcess()
        .then(response => {
          this.processing = response.processing
        })
    },
    closeFile() {
      this.fileCsv = null;
    },
    // uploadFile: temporarily removed while back-end is being adapted
    // uploadFile() {
    //   const formData = new FormData();
    //   formData.set("file_csv", this.fileCsv);
    //   this.processing = true;
    //   service.uploadCsv(this.$route.params.uuid, formData).then((res) => {
    //     if (res.results) {
    //       this.fileCsv = null;
    //       this.modal_csv_import = false;
    //       loadToastificationContent().then((component) => {
    //         this.$toast({
    //           component: component.default,
    //           props: {
    //             title: this.$t('lists.addSuccess'),
    //             icon: "CheckCircleIcon",
    //             text: this.$t('lists.addSuccessText'),
    //             variant: "success",
    //           }
    //         },
    //         {
    //           timeout: 20000
    //         })
    //       })
    //       service_profile.getMaxViews()
    //         .then(response => {
    //           this.$root.$emit('change_max_views', response.max_views)
    //         })
    //     } else if (res.code && res.code === 'csv.BadFormat') {
    //       this.$swal({
    //         title: this.$t('lists.errorCsv'),
    //         text:  this.$t('lists.formatCsv'),
    //         imageUrl: require('@/assets/images/lists/example_csv.png'),
    //         imageWidth: 400,
    //         imageHeight: 200,
    //         icon: 'danger',
    //         customClass: {
    //           confirmButton: 'btn btn-danger'
    //         },
    //         buttonsStyling: false,
    //         heightAuto: false,
    //       })
    //     } else if (res.code && res.code === 'campaign.Processing') {
    //       this.$swal({
    //         title: this.$t('lists.titleCsvProcess'),
    //         text: this.$t('lists.textCvsProcess'),
    //         icon: 'danger',
    //         customClass: {
    //           confirmButton: 'btn btn-danger'
    //         },
    //         buttonsStyling: false,
    //         heightAuto: false,
    //       })
    //     } else if (res.code && res.code === 'accounts.max_views_soldout') {
    //       this.$swal({
    //         title: this.$t('error.soldoutViews'),
    //         icon: 'danger',
    //         customClass: {
    //           confirmButton: 'btn btn-danger'
    //         },
    //         buttonsStyling: false,
    //         heightAuto: false,
    //       })
    //     }
    //   });
    // },
    isSuperUser() {
      return getUserData().is_superuser
    },
    influencerAdded() {
      this.key_all += 1;
      this.key_pending += 1;
      this.getCampaignData(this.$route.params.uuid)
    },
    updateCounter() {
      this.getCampaignData(this.$route.params.uuid);
    },
    getCampaignData(campaign_uuid) {
      service.getCampaignInfluencers(campaign_uuid, 1, 1)
        .then(response => {
          if (response.results && response.results.length > 0) {
            const influencer = response.results[0]

            this.formatHeader(influencer.campaign_header)
          } else {
            this.header_data.production = 0
            this.header_data.proposals = 0
            this.header_data.published = 0
            this.header_data.onboarding = 0
            this.header_data.trading = 0
            this.header_data.pending = 0
            this.header_data.approved = 0
            this.header_data.rejected = 0
            this.header_data.submitted = 0
          }
        })
    },
    disabledUpdateCampaign() {
      return !hasPermission('change_campaign')
    },
  },
  mounted () {
  },
  beforeDestroy () {
    this.$root.$off('youtube_ycp_campaign_locked')
  },
  watch: {
    principal_tabs() {
      const sections = [
        '#propuestas',
        '#squad',
        '#contenidos',
        '#calendario',
        '#overview',
        '#analytics'
      ]

      history.pushState({urlPath:""},"",sections[this.principal_tabs]);
      this.updated_all_user += 1;
    },
    secondary_tabs_proposals() {
      let sections = [
        '#propuestas',
        '#propuestas-pendientes',
        '#propuestas-aprobadas',
        '#propuestas-rechazadas',
      ];
      sections = sections.concat(this.checkOverviewUrl())
      const interval = setInterval(() => {
        if (this.principal_tabs === 0) {
          history.pushState({urlPath:""},"",sections[this.secondary_tabs_proposals]);
          clearInterval(interval)
        }
      },500)  
    },
    tabs_content() {
      const sections = [
        '#contenidos',
        '#contenidos-vista'
      ]
      const interval_content = setInterval(() => {
        if (this.principal_tabs === 2) {
          history.pushState({urlPath:""},"",sections[this.tabs_content]);
          clearInterval(interval_content)
        }
      },500)
    }
  }
}
</script>

<style>
.b-sidebar{
  width: 500px !important;
}
.button-csv{
  background-color: transparent !important;
  color:grey !important;
  border: grey solid 1px !important;
  margin-left: 5px !important;
}
.button-csv:focus{
  background-color: transparent !important;
  color:grey !important;
  border: grey solid 1px !important;
  margin-left: 5px !important;
}
.button-brief{
  margin-right: 10px;
}
.campaign-tabs-principal-inner .nav-link{
  color: #868fb6 ;
}
.campaign-tabs-principal-inner .nav-link:hover {
  color: #bfbfc8;
}
.campaign-tabs-principal-active {
  /* color: #4826ef !important; */
  border-bottom: 2px solid var(--primary, #4826ef) !important;
}
.nav-tabs .nav-link:after {
  background: none !important;
}


/* ── YouTube channel alert banner ── */
.yt-alert-wrapper {
  max-width: 860px;
  margin: 10px auto 0;
  border-radius: 10px;
  padding: 2px;
  position: relative;
  z-index: 5;
}
.yt-alert--warning {
  background: linear-gradient(135deg, #ff9f43, #ffbe76);
  box-shadow: 0 4px 16px rgba(255, 159, 67, 0.3);
}
.yt-alert--danger {
  background: linear-gradient(135deg, #ea5455, #ff7f7f);
  box-shadow: 0 4px 16px rgba(234, 84, 85, 0.3);
}
.yt-alert-inner {
  background: rgba(255,255,255,0.92);
  border-radius: 8px;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.yt-alert-icon {
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.yt-alert--warning .yt-alert-icon {
  background: rgba(255,159,67,0.15);
  color: #e08d00;
}
.yt-alert--danger .yt-alert-icon {
  background: rgba(234,84,85,0.12);
  color: #ea5455;
}
.yt-alert-content {
  flex: 1;
  min-width: 0;
}
.yt-alert-title {
  margin: 0 0 2px;
  font-weight: 600;
  font-size: 14px;
  color: #2d2d2d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.yt-alert-msg {
  margin: 0;
  font-size: 12px;
  color: #555;
  line-height: 1.45;
}
.yt-alert-btn {
  white-space: nowrap;
}
.yt-alert-close {
  flex-shrink: 0;
  background: transparent;
  border: none;
  color: #999;
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s, color 0.15s;
  line-height: 1;
}
.yt-alert-close:hover {
  background: rgba(0,0,0,0.06);
  color: #555;
}
.yt-alert-fade-enter-active, .yt-alert-fade-leave-active {
  transition: opacity 0.25s, transform 0.25s;
}
.yt-alert-fade-enter, .yt-alert-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
</style>
